import { render } from "./Cybervorfall.vue?vue&type=template&id=0a7e4cec&scoped=true"
import script from "./Cybervorfall.vue?vue&type=script&lang=js"
export * from "./Cybervorfall.vue?vue&type=script&lang=js"

import "./Cybervorfall.vue?vue&type=style&index=0&id=0a7e4cec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a7e4cec"]])

export default __exports__